import { getEigenstromTypen } from '../../helpers/getEigenstromTypen';
import { getStandorte } from '../../helpers/getStandorte';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import { StructureService } from '../../services/structure_service';
import { RoutingIDs } from '../../helpers/RoutingIDs';
import { Validierung } from '../../bereiche/datenauswertung/elements/Validierung';

export class StammdatenPlausibel {

    public constructor(data: any) {
        this.data = data || {};
        this.isGefuehrterModus = (this.data[IDs.ENT_KONFIGURATION] || []).some((param: any) => param.gefuehrter_modus_orig === 1);
        this.getKonfiguration();
        this.getStandorte();
        this.getUnternehmensdaten();
    }

    @lazyInject(StructureService) private structureService: StructureService;

    private data: any;
    private eigenstromTypen: any = [
        { id: 1, entity: IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT },
        { id: 2, entity: IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK },
        { id: 3, entity: IDs.ENT_ANLAGEN_EIGENSTROM_KWK },
        { id: 4, entity: IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE },
        { id: 5, entity: IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN },
        { id: 6, entity: IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE }
    ];
    private eintraege: any[] = [];
    private isGefuehrterModus: boolean;
    private typ = 'stamm';
    private debug = false;

    public getData(): any[] {
        return this.eintraege;
    }

    private getEigenstromByTyp(eigenstrom: any): any[] {
        const data: any[] = [];
        const standort: number = (eigenstrom.length && eigenstrom[0].standort_tid_orig)
            ? eigenstrom[0].standort_tid_orig
            : null;

        this.eigenstromTypen.forEach((typ: any) => {
            const { entity, id } = typ;
            const dataEntity: any = this.data[entity] || [];
            const item = dataEntity.length
                ? dataEntity.filter((dataItem: any) => dataItem.standort_tid_orig === standort)
                : [];

            if (eigenstrom.map((itemEigenstrom: any) => itemEigenstrom.anlagen_eigenstrom_typ_tid_orig).indexOf(id) > -1) {
                data.push({ [entity]: item });
            }
        });

        return data;
    }

    private getKonfiguration(): void {
        const entity: string = IDs.ENT_KONFIGURATION || null;
        const data: any[] = this.data[entity] || [];
        const path: any = this.isGefuehrterModus ? RoutingIDs.ROUTE_DATENEINGABE : RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_KONFIGURATION;
        const standortTid: number = ((getStandorte(this.data) || [])
            .find((standort: any) => (standort.standort_typ_tid_orig || standort.standort_typ_tid) === 1) || {}).tid || null;
        const tid: number = (data[0] || {}).tid || null;
        const routing: any = { [IDs.ENT_STANDORT]: standortTid, key: 'checkConfig', [entity]: tid, path, entities: [entity] };
        const eintrag: any = { entity, tid, typ: 'konfiguration', level: 'error', routing };
        const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entity) || {};
        const validation: any = new Validierung(this.data, null, [{ titel: structure.TITEL, entity }], 'tid').getData();
        const hasErrors: boolean = this.hasErrors(validation, entity, tid);

        if (hasErrors) {
            this.eintraege.push({
                ...eintrag,
                text: 'Die Konfiguration ist fehlerhaft',
                validation
            });
        }

        if (data.length > 1) {
            this.eintraege.push({
                ...eintrag,
                text: 'Ihrem Tool sind mehrere Konfigurationen zugeordnet',
                validation: {}
            });
        }
    }

    private getStandorte(): void {
        const anlagen_eigenstrom: any[] = this.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [];
        const eigenstromTypen: any[] = getEigenstromTypen(this.data) || [];
        const entity: string = IDs.ENT_STANDORT || null;
        // const entityEnergietraeger: string = IDs.ENT_STANDORT_ENERGIETRAEGER || null;
        // const standort_energietraeger: any[] = this.data[entityEnergietraeger] || [];
        const standorte: any = getStandorte(this.data) || [];

        standorte.forEach((standort: any) => {
            const { name, tid } = standort;
            const disabledErneuerbareEnergien: boolean = !(this.data[IDs.ENT_KONFIGURATION] || [])
                .some((param: any) => param.daten_erneuerbare_energien_orig === 1);
            const eintrag: any = { entity, tid, typ: this.typ };
            const routing: any = { key: 'inputTechnik', [entity]: tid };
            let level: string = null;
            let text: string = null;
            let typen: any = [];

            if (!disabledErneuerbareEnergien) {
                const eigenstrom = anlagen_eigenstrom
                    ? anlagen_eigenstrom.filter((item: any) => (+item.standort_tid_orig || null) === tid)
                    : [];
                /*const energietraeger = standort_energietraeger
                    ? standort_energietraeger
                        .filter((item: any) => (
                            item.standort_tid_orig
                            && +item.standort_tid_orig === tid
                        ))
                    : [];*/
                typen = this.getEigenstromByTyp(eigenstrom);
            }

            /*if (energietraeger.length) {
                level = 'ok';
                text = `Die Energieträger für den Standort ${name} wurden angegeben`;
            } else {
                level = 'error';
                text = `Die Energieträger für den Standort ${name} wurden nicht angegeben`;
            }
            this.eintraege.push({
                ...eintrag,
                level: level,
                routing: { ...routing, [entityEnergietraeger]: energietraeger.map((item: any) => item.tid), path: RoutingIDs.ENTITY_ROUTES[entityEnergietraeger] },
                text: text,
            });
            */
            if (this.debug) {
                console.log({typen});
            }

            if (!typen.length) {
                return;
            }

            typen.forEach((typ: any) => {
                const entityEigenstromTyp: string = (Object.keys(typ) || [])[0] || null;
                const id = (this.eigenstromTypen.find((item: any) => item.entity === entityEigenstromTyp) || {}).id;
                const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entityEigenstromTyp) || {};
                const validation: any = new Validierung(
                    this.data, tid, [{ titel: structure.TITEL, entity: entityEigenstromTyp }], 'standort_tid'
                ).getData();

                if (this.debug) {
                    console.log({structure});
                }
                const eigenstromTyp: any[] = typ[entityEigenstromTyp] || [];
                const path: any = this.isGefuehrterModus
                    ? {
                        ...RoutingIDs.ROUTE_DATENEINGABE,
                        [RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN]: eigenstromTypen.findIndex((item: any) => item.tid === id) + 1,
                        terminateOn: RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN
                    }
                    : {
                        ...RoutingIDs.ROUTE_DATENEINGABE_ERNEUERBARE_ENERGIEN,
                        [RoutingIDs.TABS_DATENEINGABE_ERNEUERBARE_ENERGIEN]: standorte.findIndex((standort: any) => standort.tid === tid),
                        [RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN]: eigenstromTypen.findIndex((item: any) => item.tid === id) + 1,
                        terminateOn: RoutingIDs.TABS_STANDORTE_ERNEUERBARE_ENERGIEN
                    };
                if (eigenstromTyp.length) {
                    const hasErrors: boolean = this.hasErrors(validation, entityEigenstromTyp);
                    level = hasErrors ? 'error' : 'ok';
                    text = `Es liegen${hasErrors ? ' fehlerhafte' : ''} Anlagendaten für ${structure.TITEL} des Standortes ${name} vor`;
                } else {
                    level = 'warning';
                    text = `Bei der Auswahl der erneuerbaren Energien wurde ${structure.TITEL} ausgewählt, es liegen jedoch keine Anlagendaten für den Standort ${name} vor`;
                }
                this.eintraege.push({
                    ...eintrag,
                    level,
                    routing: {
                        ...routing, [entityEigenstromTyp]: eigenstromTyp.map((item: any) => item.tid), path, entities: [entityEigenstromTyp]
                    },
                    text,
                    validation
                });
            });
        });
    }

    private getUnternehmensdaten(): void {
        const entity: string = IDs.ENT_UNTERNEHMENSDATEN || null;
        const data: any[] = this.data[entity] || [];
        const path: any = this.isGefuehrterModus ? RoutingIDs.ROUTE_DATENEINGABE : RoutingIDs.ROUTE_BETRIEBLICHE_DATEN_UNTERNEHMENSDATEN;
        const standortTid: number = ((getStandorte(this.data) || [])
            .find((standort: any) => (standort.standort_typ_tid_orig || standort.standort_typ_tid) === 1) || {}).tid || null;
        const tid: number = (data[0] || {}).tid || null;
        const routing: any = { [IDs.ENT_STANDORT]: standortTid, key: 'checkUnternehmen', [entity]: tid, path, entities: [entity] };
        const eintrag: any = { entity, tid, typ: 'unternehmen', level: 'error', routing };
        const structure: any = this.structureService.getStructureByKey(IDs.MOD_ETOOL, entity) || {};
        const validation: any = new Validierung(this.data, null, [{ titel: structure.TITEL, entity }], 'tid').getData();
        const hasErrors: boolean = this.hasErrors(validation, entity, tid);

        if (hasErrors) {
            this.eintraege.push({
                ...eintrag,
                text: 'Die Unternehmensdaten sind fehlerhaft',
                validation
            });
        }

        if (data.length > 1) {
            this.eintraege.push({
                ...eintrag,
                text: 'Ihrem Tool sind mehrere Unternehmensdatensätze zugeordnet',
                validation: {}
            });
        }
    }

    private hasErrors(validation: any, entity: string, forcedTid: number = null): boolean {
        validation = validation || {};
        const tid: number = forcedTid || +Object.keys(validation)[0] || null;
        const data: any = ((validation || {})[tid] || {})[entity] || {};

        return Object.keys(data).some((id: string) => Object.keys(data[id]).some((key: string) => data[id][key].type === 'error'));
    }
}
